import React from 'react';
import { Carousel, Grid } from 'antd';

import AppHeader from '../../../../Layout/Header';
import FooterComponent from '../../../../Layout/Footer';
import SummerSchoolVideoArchive from './SummerSchoolVideoArchive';
import SummerSchoolMediaCoverage from './SummerSchoolMediaCoverage';

import banner from '../../../../Assets/Linkages/SpaceSummerSchool/Space-Summer-School-Banner.jpg';

import summerSchoolImageOne from '../../../../Assets/Linkages/SpaceSummerSchool/Summer-School-01.jpeg';
import summerSchoolImageTwo from '../../../../Assets/Linkages/SpaceSummerSchool/Summer-School-02.jpg';
import summerSchoolImageThree from '../../../../Assets/Linkages/SpaceSummerSchool/Summer-School-03.jpg';

import decadePosterOne from '../../../../Assets/Linkages/SpaceSummerSchool/Decade-Poster-01.png';
import decadePosterTwo from '../../../../Assets/Linkages/SpaceSummerSchool/Decade-Poster-02.png';

import legacy2017 from '../../../../Assets/Linkages/SpaceSummerSchool/Legacy/SSS-2017.png';
import legacy2018 from '../../../../Assets/Linkages/SpaceSummerSchool/Legacy/SSS-2018.jpg';
import legacy2019 from '../../../../Assets/Linkages/SpaceSummerSchool/Legacy/SSS-2019.jpg';
import legacy2020 from '../../../../Assets/Linkages/SpaceSummerSchool/Legacy/SSS-2020.jpg';
import legacy2021 from '../../../../Assets/Linkages/SpaceSummerSchool/Legacy/SSS-2021.png';
import legacy2022 from '../../../../Assets/Linkages/SpaceSummerSchool/Legacy/SSS-2022.jpg';
import legacy2023 from '../../../../Assets/Linkages/SpaceSummerSchool/Legacy/SSS-2023.png';
import legacy2024 from '../../../../Assets/Linkages/SpaceSummerSchool/Legacy/SSS-2024.jpg';
import legacy2025 from '../../../../Assets/Linkages/SpaceSummerSchool/Legacy/SSS-2025.jpg';
import legacy2026 from '../../../../Assets/Linkages/SpaceSummerSchool/Legacy/SSS-2026.jpg';

import '../../../../Styles/Linkages&Outreach.css';
const { useBreakpoint } = Grid;





/* =========================================================
   INTRODUCTION CAROUSEL IMAGES
   ========================================================= */

const carouselImages = [
  {
    src: summerSchoolImageOne,
    alt: 'Space Summer School participants',
  },
  {
    src: summerSchoolImageTwo,
    alt: 'Space Summer School activities',
  },
  {
    src: summerSchoolImageThree,
    alt: 'Space Summer School learning session',
  },
];


/* =========================================================
   LEGACY POSTERS
   ========================================================= */

const legacyPosters = [
  {
    src: legacy2017,
    year: '2017',
  },
  {
    src: legacy2018,
    year: '2018',
  },
  {
    src: legacy2019,
    year: '2019',
  },
  {
    src: legacy2020,
    year: '2020',
  },
  {
    src: legacy2021,
    year: '2021',
  },
  {
    src: legacy2022,
    year: '2022',
  },
  {
    src: legacy2023,
    year: '2023',
  },
  {
    src: legacy2024,
    year: '2024',
  },
  {
    src: legacy2025,
    year: '2025',
  },
  {
    src: legacy2026,
    year: '2026',
  },
];


/* =========================================================
   LEGACY CAROUSEL SETTINGS
   ========================================================= */

const legacySliderSettings = {
  autoplay: true,
  autoplaySpeed: 2600,
  dots: true,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,

  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },

    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },

    {
      breakpoint: 520,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};


/* =========================================================
   SPACE SUMMER SCHOOL COMPONENT
   ========================================================= */

const SpaceSummerSchool = () => {
  const screens = useBreakpoint();


  return (
    <>
      <AppHeader />


      <main className="space-summer-school-page">


        {/* =====================================================
            HERO BANNER
            ===================================================== */}

        <section className="space-summer-school-hero">

          <img
            className="space-summer-school-banner"
            src={banner}
            alt="Space Summer School"
          />

        </section>


        {/* =====================================================
            INTRODUCTION
            ===================================================== */}

        <section className="summer-school-overview">

          <div className="summer-school-overview-inner">


            {/* =================================================
                INTRODUCTION TEXT
                ================================================= */}

            <div className="summer-school-introduction">

              <div className="summer-school-content">

                <p className="summer-school-eyebrow">
                  Discover. Explore. Innovate.
                </p>

                <h1>
                  Introduction
                </h1>

                <div className="summer-school-title-line" />

                <p
                  className="summer-school-intro-text"
                  style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' // Optional: custom color
          }} 
                >
                  Space Summer School is a dynamic annual program tailored
                  for school and college students, designed to ignite
                  curiosity and passion for space science, technology, and
                  its real-world applications. Through an engaging blend of
                  hands-on activities, interactive learning sessions, and
                  collaborative team projects, students explore exciting
                  domains such as Astronomy &amp; Astrophysics, Earth and
                  Environmental Sciences, Aviation, Rocketry, and Satellite
                  Technology. The program offers young minds a unique
                  opportunity to delve into the wonders of the universe while
                  developing critical thinking, creativity, and
                  problem-solving skills. By immersing participants in the
                  rapidly evolving world of space exploration, Space Summer
                  School aims to inspire the next generation of scientists,
                  engineers, and innovators who will shape the future of
                  space.
                </p>

              </div>

            </div>


            {/* =================================================
                INTRODUCTION GALLERY
                ================================================= */}

            <div
              className="summer-school-gallery"
              aria-label="Space Summer School gallery"
            >

              <div className="summer-school-gallery-inner">

                <Carousel
                  autoplay
                  autoplaySpeed={2500}
                  dots
                  effect="fade"
                >

                  {carouselImages.map((image, index) => (

                    <div
                      key={`${image.alt}-${index}`}
                      className="summer-school-slide"
                    >

                      <img
                        src={image.src}
                        alt={image.alt}
                      />

                    </div>

                  ))}

                </Carousel>

              </div>

            </div>

          </div>

        </section>


        {/* =====================================================
            A DECADE OF IMPACT
            ===================================================== */}

        <section className="summer-school-decade">

          <div className="summer-school-decade-inner">


            {/* Text */}

            <div className="summer-school-decade-copy">

              <p className="summer-school-eyebrow">
                Ten Years of Impact
              </p>

              <h2>
                A Decade of Inspiring Pakistan&apos;s Future Space Explorers
              </h2>

              <div className="summer-school-title-line" />

              <p  style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' // Optional: custom color
          }} >
                For ten years, Space Summer School has turned youthful
                curiosity into genuine ambition, empowering young minds to
                dream boldly and reach beyond the horizon. Its legacy
                endures in the learners, innovators, and future space
                leaders it continues to inspire—a lasting testament to a
                shared passion for discovery.
              </p>

            </div>


            {/* Posters */}

            <div className="summer-school-poster-gallery">

              <figure
                className="
                  summer-school-poster
                  summer-school-poster-primary
                "
              >

                <img
                  src={decadePosterOne}
                  alt="Space Summer School decade poster"
                />

              </figure>


              <figure
                className="
                  summer-school-poster
                  summer-school-poster-secondary
                "
              >

                <img
                  src={decadePosterTwo}
                  alt="Space Summer School program poster"
                />

              </figure>

            </div>

          </div>

        </section>


        {/* =====================================================
            OUR LEGACY
            ===================================================== */}

        <section className="summer-school-legacy">

          <div className="summer-school-legacy-inner">


            {/* Legacy Heading */}

            <header className="summer-school-legacy-header">

              <p className="summer-school-eyebrow">
                2017–2026
              </p>

              <h2>
                Our Legacy
              </h2>

              <div className="summer-school-title-line" />

              <p  style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' // Optional: custom color
          }} >
                The Space Summer School has been inspiring young minds
                since 2017, hosted annually at the Institute of Space
                Technology (IST), Islamabad. Designed for students from
                Grade 6 to 12, the program offers a unique blend of space
                science, technology, and hands-on learning experiences.
                Since 2017, Space Summer School has engaged over 3000+
                students from 550+ educational institutions, offering 300+
                hours of interactive sessions, guided by 250+ subject
                experts, and delivering 200+ hours of hands-on STEM
                activities, providing students with immersive learning
                experiences in space science, technology, and its
                real-world applications.
              </p>

            </header>


            {/* Legacy Poster Slider */}

            <div className="summer-school-legacy-slider">

              <Carousel  {...legacySliderSettings}>

                {legacyPosters.map((poster) => (

                  <div
                    key={poster.year}
                    className="summer-school-legacy-slide"
                  >

                    <figure>

                      <img
                        src={poster.src}
                        alt={`Space Summer School ${poster.year} poster`}
                      />

                      <figcaption>
                        Space Summer School {poster.year}
                      </figcaption>

                    </figure>

                  </div>

                ))}

              </Carousel>

            </div>

          </div>

        </section>

        <SummerSchoolVideoArchive />

        <SummerSchoolMediaCoverage />

      </main>


      <FooterComponent />

    </>
  );
};


export default SpaceSummerSchool;
